export function loadingStart() {
  let loadingScreenContainer = document.getElementById('loading-screen');
  if (loadingScreenContainer) {
      return;
  }
  
  document.body.classList.add("page-loading");

  loadingScreenContainer = document.createElement('div');
  loadingScreenContainer.setAttribute("id", "loading-screen");

  let logoContainer = document.createElement("div");
  logoContainer.classList.add("loading-screen__logo");
  loadingScreenContainer.appendChild(logoContainer);

  document.body.appendChild(loadingScreenContainer);

}

export function loadingEnd() {
    let loadingScreenContainer = document.getElementById("loading-screen");

    setTimeout(() => {
      document.body.classList.add("page-loading--hide");
      document.body.classList.remove("page-loading");
    }, 500);

    setTimeout(() => {
        document.body.classList.remove("page-loading--hide");
        loadingScreenContainer.remove();
    }, 1000);
}
